import { OpeningItem } from './OpeningItem';
export default OpeningItem;
